import mergeVariables from '../../../fe-brary-internals/merge-variables';
var neutrals = () => ({
  colour: {
    white: '#fff',
    black: '#000',
    neutral50: '#fafbfc',
    neutral100: '#f2f5f7',
    neutral200: '#e6e9ed',
    neutral300: '#d0d3d9',
    neutral400: '#a9afba',
    neutral500: '#7e8594',
    neutral600: '#515b6e',
    neutral700: '#3c475b',
    neutral800: '#1e293d',
    neutral900: '#000'
  }
});
var neutralTexts = context => ({
  colour: {
    neutral50Text: context.colour.neutral700,
    neutral100Text: context.colour.neutral700,
    neutral200Text: context.colour.neutral700,
    neutral300Text: context.colour.neutral700,
    neutral400Text: context.colour.neutral700,
    neutral500Text: context.colour.white,
    neutral600Text: context.colour.white,
    neutral700Text: context.colour.white,
    neutral800Text: context.colour.white,
    neutral900Text: context.colour.white
  }
});
var palette = context => ({
  colour: {
    primaryLight: context.colour.domainNavy400,
    primary: context.colour.domainNavy500,
    primaryDark: context.colour.domainNavy600,
    primaryLightText: context.colour.white,
    primaryText: context.colour.white,
    primaryDarkText: context.colour.white,
    secondaryLight: context.colour.rtaBlue400,
    secondary: context.colour.rtaBlue500,
    secondaryDark: context.colour.rtaBlue600,
    secondaryLightText: context.colour.white,
    secondaryText: context.colour.white,
    secondaryDarkText: context.colour.white,
    accentLight: context.colour.domainLobster100,
    accent: context.colour.domainLobster500,
    accentDark: context.colour.domainLobster600,
    accentLightText: context.colour.neutral800,
    accentText: context.colour.white,
    accentDarkText: context.colour.white
  }
});
var namedColours = context => ({
  colour: {
    brandGreen25: context.colour.rtaBlue25,
    brandGreenLight: context.colour.rtaBlue50,
    brandGreen: context.colour.rtaBlue500,
    brandGreenDark: context.colour.rtaBlue600,
    brandOrangeLight: context.colour.domainLobster100,
    brandOrange: context.colour.domainLobster500,
    brandOrangeDark: context.colour.domainLobster600,
    brandYellowLight: context.colour.domainCanary100,
    brandYellow: context.colour.domainCanary500,
    brandYellowDark: '#ffa200',
    brandAquaLight: context.colour.domainTurquoise100,
    brandAqua: context.colour.domainTurquoise500,
    brandPurple: context.colour.domainGrimace500,
    brandBlue: context.colour.domainBlurple500,
    brandBlueDark: context.colour.domainNavy500
  }
});
export default (context => mergeVariables(neutrals, neutralTexts, palette, namedColours)(context));